import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { BasicResponse } from '../../utils/basic-response/basic-response.model';

@Injectable()
export class SystemConfigGuestService {
  private cacheForKey = new Map<string, Observable<string>>();
  constructor(private httpClient: HttpClient) {}

  getSysConfigGuestValueByKey(key: string): Observable<string> {
    return this.httpClient
      .get<BasicResponse>(`/api/system/konfig/guest/${key}`)
      .pipe(
        map((data) => data.Result),
        catchError((error) => {
          console.error(`Error fetching system config for key ${key}:`, error);

          return of(null);
        }),
      );
  }

  getSysConfigGuestValueByKeyCached(key: string): Observable<string> {
    if (!this.cacheForKey.has(key)) {
      const observable = this.getSysConfigGuestValueByKey(key).pipe(
        shareReplay(1),
      );
      this.cacheForKey.set(key, observable);
    }
    return this.cacheForKey.get(key) as Observable<string>;
  }
}
